export default "__VITE_ASSET__XdyEf6O___"